module.exports = __webpack_public_path__ + "img/partnership-cyberventures copy.21c12545.png";